<template>
  <div class="about-us">
    <!-- Video Background -->
    <div class="video-hero">
      <video autoplay muted loop playsinline>
        <source src="/videos/hero-bg.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div class="overlay"></div>

      <!-- Hero Text -->
      <div class="hero-text text-center">
        <h1>{{ company.name }}</h1>
        <p class="lead">{{ company.tagline }}</p>
      </div>
    </div>

    <!-- Page Content -->
    <div class="container py-5">
      <!-- Mission & Vision -->
      <div class="row mb-4">
        <div class="col-md-6">
          <div class="card p-4 shadow-sm bg-white">
            <h5 class="card-title">Our Mission</h5>
            <p class="card-text">{{ company.mission }}</p>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card p-4 shadow-sm bg-white">
            <h5 class="card-title">Our Vision</h5>
            <p class="card-text">{{ company.vision }}</p>
          </div>
        </div>
      </div>

      <!-- Team Members -->
      <div class="team mb-5">
        <h3 class="mb-3 text-center">Meet the Team</h3>
        <div class="row g-3">
          <div class="col-md-4" v-for="member in team" :key="member.id">
            <div class="card text-center p-3 shadow-sm h-100 bg-white">
              <img :src="member.photo" alt="Photo" class="rounded-circle mb-2" width="100" height="100" />
              <h6>{{ member.name }}</h6>
              <small class="text-muted">{{ member.role }}</small>
              <p class="mt-2">{{ member.bio }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Contact Info -->
      <div class="contact-info card p-4 shadow-sm bg-white">
        <h5>Contact Us</h5>
        <ul class="list-unstyled mb-0">
          <li><strong>Email:</strong> {{ company.email }}</li>
          <li><strong>Phone:</strong> {{ company.phone }}</li>
          <li><strong>Address:</strong> {{ company.address }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const company = ref({
  name: 'Puagme Inc.',
  tagline: 'Smarter Inventory Management for Businesses',
  mission: 'To simplify inventory tracking and help businesses make data-driven decisions.',
  vision: 'To be the leading platform for intelligent inventory insights worldwide.',
  email: 'memega428@gmail.com',
  phone: '0944822329',
  address: 'Bole, Addis Ababa, Ethiopia'
})

const team = ref([
  { id: 1, name: 'Yeabsira Abera', role: 'CEO', bio: 'Founder and visionary behind Puagme, with 10 years in logistics management.', photo: 'https://i.pravatar.cc/100?img=1' },
  { id: 2, name: 'Bob Smith', role: 'CTO', bio: 'Leads the tech team and ensures smooth performance across all systems.', photo: 'https://i.pravatar.cc/100?img=2' },
  { id: 3, name: 'Clara Davis', role: 'Operations Manager', bio: 'Handles day-to-day operations and client success management.', photo: 'https://i.pravatar.cc/100?img=3' }
])
</script>

<style scoped>
.about-us {
  font-family: 'Segoe UI', sans-serif;
}

/* ---------------- Video Hero ---------------- */
.video-hero {
  position: relative;
  height: 50vh;
  width: 100%;
  overflow: hidden;
}

.video-hero video {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  transform: translate(-50%, -50%);
  z-index: 0;
  filter: brightness(50%);
}

.video-hero .overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.3);
  z-index: 1;
}

.hero-text {
  position: relative;
  z-index: 2;
  color: #fff;
  top: 50%;
  transform: translateY(-50%);
}

.hero-text h1 {
  font-size: 2.8rem;
  font-weight: bold;
}

.hero-text p.lead {
  font-size: 1.2rem;
}

/* ---------------- Cards & Content ---------------- */
.card {
  border: none;
  border-radius: 0.5rem;
}

.team img {
  object-fit: cover;
}

.contact-info {
  margin-top: 2rem;
}
</style>
